// extracted by mini-css-extract-plugin
export default {"backups":"style_backups__H2tli"};